import { createFileRoute } from '@tanstack/react-router'
import { RelatorioRedes } from '@/features/relatorios-redes'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute(
  '/_authenticated/relatorios/redes/',
)({
  beforeLoad: async () => {
    await requireAdmin()
  },
  component: RelatorioRedes,
})
